import { render, staticRenderFns } from "./bannedAccountModal.vue?vue&type=template&id=277b6fd1&scoped=true&"
import script from "./bannedAccountModal.vue?vue&type=script&lang=js&"
export * from "./bannedAccountModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "277b6fd1",
  null
  
)

export default component.exports